import React from 'react';
import responsiveClasses from '../payment-form-styling/payment-form-styling.scss';
import fixedClasses from '../payment-form-styling/payment-form-styling-fixed.scss';
export class FormRow extends React.PureComponent {
  render() {
    const {
      children,
      isFixedStyles = false
    } = this.props;
    const classes = isFixedStyles ? fixedClasses : responsiveClasses;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.row
    }, children);
  }
}